/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { DefaultAttributeMappingPageEntrypointProps } from './DefaultAttributeMappingPage.entrypoint.types.tsx';

type DefaultAttributeMappingEntryPointComponent = EntryPointComponent<
	{},
	{},
	DefaultAttributeMappingPageEntrypointProps,
	{}
>;

export const defaultAttributeMappingEntryPoint: EntryPoint<
	DefaultAttributeMappingEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<DefaultAttributeMappingEntryPointComponent>(
		/* webpackChunkName: "async-default-attribute-mapping-page" */ './DefaultAttributeMappingPage.tsx',
	),
	getPreloadProps: () => ({
		extraProps: {},
	}),
});
